import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import AllTools from '@/views/AllTools.vue';
import Applications from '@/views/Applications.vue';
import Framework from '@/views/Framework.vue';
import SearchAll from '@/views/searchall.vue';
import OpenSourceModels from '@/views/OpenSourceModels.vue';
import ClosedSourceModels from '@/views/ClosedSourceModels.vue';
import ApplicationScenarios from '@/views/ApplicationScenarios.vue';
import AboutUs from '@/views/AboutUs.vue';
import WebsiteGuide from '@/views/WebsiteGuide.vue';
import AIDetail from '@/views/AIDetail.vue';
import Models from '@/views/models.vue';
import CardDetail from '@/views/CardDetail.vue'; // 工具詳細頁
import feedback from '@/views/feedback.vue'; // 工具詳細頁

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/all-tools', name: 'AllTools', component: AllTools },
  { path: '/applications', name: 'Applications', component: Applications },
  { path: '/framework', name: 'Framework', component: Framework },
  { path: '/models', name: 'Model', component: Models },
  { path: '/models/opensource', name: 'OpenSourceModels', component: OpenSourceModels },
  { path: '/models/closedsource', name: 'ClosedSourceModels', component: ClosedSourceModels },
  { path: '/application-scenarios', name: 'ApplicationScenarios', component: ApplicationScenarios },
  { path: '/about-us', name: 'AboutUs', component: AboutUs },
  { path: '/WebsiteGuide', name: 'WebsiteGuide', component: WebsiteGuide },
  { path: '/ai-detail/:id', name: 'AIDetail', component: AIDetail, props: route => ({ id: route.params.id }) },
  { path: '/search/:keyword', name: 'SearchAll', component: SearchAll, props: true },
  { path: '/tool/:id', name: 'CardDetail', component: CardDetail, props: true }, // 工具詳細頁
  { path: '/feedback', name: 'feedback', component: feedback, props: true }, // 工具詳細頁
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
